import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, Subscriber } from 'rxjs';
import { AuthBase } from './auth.base';
import { ConnectionService } from '../services/connection/connection.service';
import { UserService } from '../../user/services/user.service';
import { AuthenticationService } from '../../user/services/authentication.service';

/**
 * This guard should be a negation of auth guard to determine if login should be shown or not
 */
@Injectable({
    providedIn: 'root'
})
export class AuthPresentGuard extends AuthBase implements CanActivate {
    constructor(authenticationService: AuthenticationService,
                connectionService: ConnectionService,
                private userService: UserService,
                private router: Router) {
        super(authenticationService, connectionService);
    }

    public canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return new Observable<boolean>(subscriber => this.invertAuth(subscriber));
    }

    private invertAuth(subscriber: Subscriber<boolean>) {
        this.checkAuthorizationOriginal()
            .subscribe((isAllowed: boolean) => {
                if (isAllowed) {
                    this.redirectToHome();
                }
                subscriber.next(!isAllowed);
            });
    }

    private redirectToHome() {
        this.router.navigateByUrl('home');
    }
}
